import useDecodedParams from "Hooks/useDecodedParams";
import { useAppDispatch } from "Store/hooks";

import { deleteEnvironmentDomainThunk } from "../thunks/deleteEnvironmentDomain.thunk";

import type { Environment, EnvironmentDomain, Project } from "@packages/client";

export const useDeleteEnvironmentDomain = (
  project?: Project,
  environment?: Environment
) => {
  const dispatch = useAppDispatch();
  const { projectId } = useDecodedParams<{
    projectId: string;
  }>();

  const handleDelete = (environmentDomain: EnvironmentDomain) => {
    if (!environment || !project) return;
    dispatch(
      deleteEnvironmentDomainThunk({
        environmentDomain,
        projectId,
        environmentId: environment.id
      })
    );
  };

  return {
    handleDelete
  };
};
